export const exampleAds = [
  {
    id: 1,
    platform: "Facebook",
    platformIcon: "ri-facebook-fill",
    businessType: "HVAC & Plumbing",
    hook: "Is your AC dying just as summer hits?",
    headline: "Same-Day HVAC Repair — No Weekend Fees",
    body: "Don't sweat it. Our certified technicians are available 7 days a week with transparent pricing. Most repairs done same day. Over 2,400 five-star reviews in Austin. Call now and get $50 off your first service.",
    cta: "Book My Repair Now",
    color: "from-orange-500 to-amber-400",
    advertiserName: "CoolBreeze HVAC Austin",
    advertiserAvatar: "https://readdy.ai/api/search-image?query=professional HVAC company logo icon clean minimal orange flame snowflake icon on white background simple bold graphic design commercial&width=80&height=80&seq=hvac-avatar-01&orientation=squarish",
    imageUrl: "https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/d0a796f52e57ee16def103a2d854f259.png",
    imageTags: ["AI Copy", "AI Image", "Facebook Format"],
  },
  {
    id: 2,
    platform: "Instagram",
    platformIcon: "ri-instagram-fill",
    businessType: "Fitness Studio",
    hook: "You've been saying 'I'll start Monday' for 6 months.",
    headline: "First Month Free. No Contracts. No Excuses.",
    body: "Sculpt Studio is the no-judgment gym where real people get real results. Unlimited classes, certified coaches, and a community that actually shows up. Spots are limited — claim your free month today.",
    cta: "Claim My Free Month",
    color: "from-rose-500 to-orange-400",
    advertiserName: "Sculpt Studio",
    advertiserAvatar: "https://readdy.ai/api/search-image?query=modern fitness gym brand logo icon minimal bold letter S monogram design clean white background dark charcoal weight dumbbell icon simple geometric&width=80&height=80&seq=fitness-avatar-01&orientation=squarish",
    imageUrl: "https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/0c3df67be577a1961a595d31edba1491.png",
    imageTags: ["AI Copy", "AI Image", "Instagram Format"],
  },
  {
    id: 3,
    platform: "Google",
    platformIcon: "ri-google-fill",
    businessType: "Legal Services",
    hook: "Injured in an accident? You may be owed compensation.",
    headline: "Free Consultation | No Fee Unless You Win",
    body: "Torres Law Group has recovered over $140M for injury victims in California. We handle everything so you can focus on healing. Available 24/7. Speak to an attorney today — completely free, no obligation.",
    cta: "Get Free Legal Help",
    color: "from-amber-500 to-yellow-400",
    advertiserName: "Torres Law Group",
    advertiserAvatar: "https://readdy.ai/api/search-image?query=professional law firm logo icon minimal scales of justice icon gold amber color clean white background bold serif monogram simple elegant&width=80&height=80&seq=law-avatar-01&orientation=squarish",
    imageUrl: "https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/f58b7682f8ae27780517b321c41a3c5e.png",
    imageTags: ["AI Copy", "AI Image", "Display Ad Format"],
  },
];

export const adPlatforms = ["Facebook", "Instagram", "Google", "TikTok", "LinkedIn"];

export const toneOptions = [
  { value: "professional", label: "Professional" },
  { value: "bold", label: "Bold & Direct" },
  { value: "friendly", label: "Friendly & Casual" },
  { value: "urgent", label: "Urgent & Compelling" },
  { value: "luxury", label: "Luxury & Premium" },
  { value: "witty", label: "Witty & Creative" },
];